import { ONE_DAY } from '@/app/constants';
import { safeStorage } from '@/app/utils/client';

// 定义购买意图类型
export interface PaymentIntent {
  productId: number;
  timestamp: number;
}

// 存储键名
const PAYMENT_INTENT_KEY = 'paymentIntent';
// 过期时间 24小时
const EXPIRATION_TIME = ONE_DAY;

export const usePaymentIntent = () => {
  // 保存支付意图到localStorage
  const savePaymentIntent = (intent: PaymentIntent) => {
    safeStorage.setItem(PAYMENT_INTENT_KEY, JSON.stringify(intent));
  };

  // 清除支付意图
  const clearPaymentIntent = () => {
    safeStorage.removeItem(PAYMENT_INTENT_KEY);
  };

  // 获取支付意图
  const getPaymentIntent = (): PaymentIntent | null => {
    const intentStr = safeStorage.getItem(PAYMENT_INTENT_KEY);
    if (!intentStr) return null;

    try {
      const parsedIntent = JSON.parse(intentStr) as PaymentIntent;
      // 检查意图是否过期
      if (Date.now() - parsedIntent.timestamp > EXPIRATION_TIME) {
        clearPaymentIntent();
        return null;
      }
      return parsedIntent;
    } catch (_) {
      clearPaymentIntent();
      return null;
    }
  };

  return {
    savePaymentIntent,
    getPaymentIntent,
    clearPaymentIntent,
  };
};
